export default {
    projectList:[],
    assignment_content : null,
    assignment_content_type : null,
    creating_assignment : false,
    assignment_created : false,
    magicOtp: null,
    magicOtpLoading: false,
    magicOtpSaving: false,
    schoolMagicOtpList: [],
    schoolMagicOtpPage: { school: null, offset: 0, count: 0, hasNext: false },
    schoolMagicOtpGrades: [],
    schoolMagicOtpLoading: false,
    schoolMagicOtpSaving: false,
    schoolMagicOtpSavedAt: null
}
